import { Loading } from '@/components/loading/Loading';
import { cn } from '@/lib/utils';

import { DropzoneState } from 'react-dropzone';

import SiUploadCloud from '@/icons/SiUploadCloud';
import { FC, PropsWithChildren } from 'react';
import { InputContainer } from '../InputContainer';

export const UploadIcon = () => (
  <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M81.1351 33.9698L63.4489 16.1911C62.9195 15.6618 62.2183 15.4005 61.5136 15.4005L45.1438 15.3111C42.3285 7.65585 34.9341 2.11115 26.2238 2.11115C15.1341 2.20052 6.07007 11.2649 6.07007 22.3511C6.07007 30.9759 11.5254 38.3663 19.1803 41.1814V79.3716C19.1803 82.8916 21.9956 85.7069 25.5156 85.7069H75.5858C79.1059 85.7069 81.9212 82.8916 81.9212 79.3716L81.928 35.8152C81.928 35.1105 81.6633 34.4092 81.134 33.9692L81.1351 33.9698ZM64.24 24.7298L72.6894 33.1792L64.24 33.1758V24.7298ZM11.5298 22.3511C11.5298 14.2558 18.1298 7.56618 26.3146 7.56618C34.4993 7.56618 41.0995 14.1662 41.0995 22.3511C41.0995 30.5358 34.4995 37.1359 26.3146 37.1359C18.1299 37.1359 11.5298 30.5359 11.5298 22.3511ZM75.5911 80.3448H25.5209C24.9915 80.3448 24.6409 79.9048 24.6409 79.4648V42.5048C25.1703 42.5942 25.6962 42.5942 26.3115 42.5942C37.4012 42.5942 46.4617 33.5293 46.4617 22.444C46.4617 21.9146 46.4617 21.3887 46.3723 20.8592H58.7821V35.8192C58.7821 37.3145 60.0127 38.5487 61.5115 38.5487H76.4715V79.3789C76.4715 79.9048 76.0311 80.3448 75.5911 80.3448Z"
      fill="currentColor"
    />
    <path
      d="M28.9503 29.6551V21.6457L29.5656 22.1751C30.0949 22.7045 30.7962 22.8798 31.415 22.8798C32.1197 22.8798 32.9103 22.6151 33.4397 21.9998C34.495 20.9445 34.4091 19.1845 33.2644 18.1292L28.0738 13.2892C27.0185 12.3198 25.4338 12.3198 24.3785 13.2892L19.2738 18.1292C18.2185 19.1845 18.1291 20.8586 19.1844 21.9998C20.2397 23.0551 21.9138 23.1445 23.055 22.0892L23.6703 21.5598V29.5692C23.6703 31.0645 24.9009 32.2986 26.3997 32.2986C27.895 32.2952 28.9503 31.1504 28.9503 29.6551Z"
      fill="currentColor"
    />
  </svg>
);

interface FileInputContainerProps {
  state?: DropzoneState;
  loading?: boolean;
  placeholder?: string;
  className?: string;
}

export const FileInputContainer: FC<PropsWithChildren<FileInputContainerProps>> = ({
  state,
  loading,
  placeholder,
  className,
  children
}) => {
  return (
    <>
      {state?.isDragActive && <div className="fixed inset-0 z-10 bg-black bg-opacity-10" />}
      <InputContainer
        aria-role="button"
        className="hover:bg-primary-std z-20 flex w-full cursor-pointer flex-col items-center justify-center overflow-clip p-[1px]"
        {...state?.getRootProps()}
      >
        {children ? (
          <div
            className={cn(
              `group relative w-full overflow-clip rounded-lg`,
              state?.isDragActive && 'pointer-events-none ',
              className
            )}
          >
            {children}
            <div
              className={cn(
                'absolute inset-0 flex w-full items-center justify-center gap-4 rounded-lg bg-black bg-opacity-50 text-white transition-all',
                'opacity-0 backdrop-blur-0 transition-all group-hover:opacity-100 group-hover:backdrop-blur-sm',
                state?.isDragActive && 'opacity-100 backdrop-blur-sm'
              )}
            >
              <SiUploadCloud className="text-primary-std text-xl" />
              <p className="text-secondary-std text-sm leading-tight">{placeholder}</p>
            </div>
          </div>
        ) : (
          <div
            className={cn(
              'pointer-events-none relative flex w-full items-center justify-center gap-2 rounded-lg py-4 text-[#DADADA]',
              className
            )}
          >
            <SiUploadCloud className="text-primary-std text-xl" />
            <p className="text-secondary-std text-sm leading-tight">{placeholder}</p>
            {loading && <Loading className="bg-secondary-std absolute inset-0 rounded-lg" />}
          </div>
        )}
        <input {...state?.getInputProps()} className="hidden" />
      </InputContainer>
    </>
  );
};
